import React, { useState } from 'react';

const faqs = [
  {
    id: 1,
    question: '1. How is Neevay better than using Excel for procurement?',
    answer:
      'Neevay automates vendor discovery, quote comparisons, and negotiation tracking — saving your team hours daily and improving cost control.',
  },
  {
    id: 2,
    question: '2. What kind of vendors are available on the platform?',
    answer:
      'Neevay brings together a curated network of vendors across key construction categories: civil, MEP, finishes, plant & machinery, consumables, and more — ensuring variety, quality, and competitive pricing.',
  },
  {
    id: 3,
    question: '3. Is Neevay suitable for small or mid-size projects?',
    answer:
      "Yes. Whether you're building a villa, managing an apartment block, or running phased commercial work — Neevay's platform scales with your project size, helping small teams move fast without sacrificing control.",
  },
  {
    id: 4,
    question: '4. How quickly can we get started?',
    answer:
      'You can be fully onboarded in 1–2 business days. The platform is intuitive — no complex setup, training sessions, or IT dependencies. You\'re up and running fast.',
  },
  {
    id: 5,
    question: '5. Can leadership track savings and procurement KPIs?',
    answer:
      'Absolutely. Neevay provides real-time dashboards with visibility into savings, quote history, vendor performance, and turnaround times — helping leadership make data-backed decisions at every step.',
  },
];

export default function FAQSection() {
  const [openId, setOpenId] = useState(null);

  return (
    <section className="py-16 px-8">
      <div className='max-w-6xl mx-auto '>
      <div className="grid grid-cols-1 md:grid-cols-3 lg:mx-48 gap-6 md:gap-10">
        <h4 className="font-semibold text-2xl md:text-4xl md:p-4 text-center md:text-left">FAQs'</h4>

        <ul className="text-sm md:text-md md:col-span-2">
          {faqs.map((faq) => {
          const isOpen = openId === faq.id;
          return (
            <li
              key={faq.id}
              onClick={() => setOpenId(openId === faq.id ? null : faq.id)}
              className={`border-l-2 px-4 py-3 cursor-pointer transition-colors ${
                openId === faq.id ? 'border-orange-500' : 'border-gray-300'
              }`}
            >
              <p className="faq-question flex justify-between">
                {faq.question}

                {/* Inline Chevron Icon */}
                <svg
                  width="18"
                  height="18"
                  viewBox="0 0 24 24"
                  fill="none"
                  xmlns="http://www.w3.org/2000/svg"
                  className={`transition-transform ${openId === faq.id ? 'rotate-180' : ''}`}
                >
                  <path
                    d="M6 9L12 15L18 9"
                    stroke="currentColor"
                    strokeWidth="2"
                    strokeLinecap="round"
                    strokeLinejoin="round"
                  />
                </svg>
              </p>

              <div
                  className={`overflow-hidden transition-all duration-500 ${
                    isOpen ? 'max-h-40 opacity-100 mt-3' : 'max-h-0 opacity-0'
                  }`}
                >
                  <p className="text-gray-600">{faq.answer}</p>
                </div>
            </li>
          )})}
        </ul>
      </div>
      </div>
    </section>
  );
}